module.exports = __webpack_public_path__ + "media/v3/driver-fe5a9b7e.png";